import { SCOPE_MAP } from "../utils";

type SettingsPermissionsGoogleProps = {
  scope: string;
  scopes: string[];
  isLoading: boolean;
  onClickConnect: (scope: string) => void;
}

export default function SettingsPermissionsGoogle(props: SettingsPermissionsGoogleProps) {
  const { scope, scopes, isLoading, onClickConnect } = props;
  const details = SCOPE_MAP[scope];

  const containsFullScope = (
    scope === "https://www.googleapis.com/auth/drive.file"
    && scopes.includes("https://www.googleapis.com/auth/drive")
  );

  function handleOpenPermissions() {
    window.open("https://myaccount.google.com/permissions", "_blank");
  }

  return (
    <div className="flex items-center">
      <img src={details.icon} className="w-8 h-8 flex-shrink-0" alt="Icon" />
      <div className="flex flex-col ml-4 mr-8">
        {details.fullScope && <div className="text-green font-semibold">Full Access</div>}
        {details.limitedScope && <div className="text-yellow font-semibold">Limited Access</div>}
        {details.description}
      </div>
      {
        isLoading ? (
          <button className="btn w-32 ml-auto" disabled>Loading...</button>
        ) : (
          (scopes.includes(scope) || containsFullScope)
            ? <button className="btn btn-green w-32 ml-auto" onClick={handleOpenPermissions}>Granted</button>
            : <button
              className="btn btn-blue w-32 ml-auto"
              onClick={() => onClickConnect(scope)}
            >Authorise</button>
        )
      }
    </div>
  );
}
